import React from "react";

function ReviewCompany({handleCompanyClick, children}) {
    const handleButtonClick = (e) => {
        handleCompanyClick(children);
    }

    return (
        <button
            type="button"
            className="gb--emphasize-info"
            onClick={handleButtonClick}
        >
            {children}
        </button>
    );
}

export default ReviewCompany;